var map = {
	"./HeroImage.png": 93,
	"./Icons_Hamburger.svg": 384,
	"./bannerImage.png": 385,
	"./bannerImage_v2.png": 386,
	"./step2-challenge-gif.gif": 387,
	"./step2-frictionless.gif": 388
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 383;